import React, { useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { UtilityRibbon } from './components/UtilityRibbon';
import { Services } from './components/Services';
import { Mission } from './components/Mission';
import { InsuranceTicker } from './components/InsuranceTicker';
import { SafetyFooter } from './components/SafetyFooter';
import { Footer } from './components/Footer';
import { About } from './components/About';
import { Careers } from './components/Careers';
import { Contact } from './components/Contact';
import { Specials } from './components/Specials';
import { Reviews } from './components/Reviews';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const handleNavigate = (page: string) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white font-sans selection:bg-primary selection:text-white" data-id="element-0">
      <Header currentPage={currentPage} onNavigate={handleNavigate} data-id="element-1" />
      <main data-id="element-2">
        {currentPage === 'home' && <>
            <Hero data-id="element-3" />
            <UtilityRibbon data-id="element-4" />
            <Mission data-id="element-5" />
            <Reviews data-id="element-6" />
            <InsuranceTicker data-id="element-7" />
          </>}
        {currentPage === 'about' && <About data-id="element-8" />}
        {currentPage === 'services' && <Services data-id="element-9" />}
        {currentPage === 'specials' && <Specials data-id="element-10" />}
        {currentPage === 'careers' && <Careers data-id="element-11" />}
        {currentPage === 'contact' && <Contact data-id="element-12" />}
      </main>
      <SafetyFooter data-id="element-13" />
      <Footer onNavigate={handleNavigate} data-id="element-14" />
    </div>;
}